import { ProductFormData } from "../types/products";
import { SellingMode } from "../enums/sellingMode";
import { Unit } from "../enums/unit";

export const DefaultProductFormValues: ProductFormData = {
  name: "",
  sellingMode: SellingMode.SINGLE_ITEM,
  description: "",
  supplierId: "",
  brandName: "",
  categoryId: "",
  baseUnit: Unit.UNIT,
  isPartialSellingAllowed: false,
  storeId: ""
};

// ---------------------------------------------------------------------------
// Unit label translation keys
// ---------------------------------------------------------------------------

export const UNIT_LABEL_KEYS: Record<string, string> = {
  UNIT: "units-unit",
  KG: "units-kg",
  G: "units-g",
  L: "units-litre",
  ML: "units-ml",
  M: "units-metre",
  CM: "units-cm",
  MM: "units-mm",
  SQCM: "units-sqcm",
  OZ: "units-oz",
  LB: "units-lb",
  BOTTLE: "units-bottle"
};

/** Human-readable unit names used when translations are unavailable. */
export const UNIT_LABEL_FALLBACKS: Record<string, string> = {
  UNIT: "units",
  KG: "kilograms",
  G: "grams",
  L: "liters",
  ML: "milliliters",
  M: "meters",
  CM: "centimeters",
  MM: "millimeters",
  SQCM: "cm²",
  OZ: "ounces",
  LB: "pounds",
  BOTTLE: "bottles"
};

// ---------------------------------------------------------------------------
// Placeholder example values — keyed by translation key for locale-safety
// ---------------------------------------------------------------------------

export const PURCHASE_PRICE_EXAMPLES: Record<string, number> = {
  "units-unit": 1500,
  "units-kg": 800,
  "units-g": 5,
  "units-litre": 1200,
  "units-ml": 3,
  "units-metre": 2500,
  "units-cm": 50,
  "units-mm": 10,
  "units-sqcm": 30,
  "units-oz": 200,
  "units-lb": 600,
  "units-bottle": 2500
};

export const SALES_PRICE_EXAMPLES: Record<string, number> = {
  "units-unit": 2000,
  "units-kg": 1200,
  "units-g": 8,
  "units-litre": 1800,
  "units-ml": 5,
  "units-metre": 3500,
  "units-cm": 75,
  "units-mm": 15,
  "units-sqcm": 45,
  "units-oz": 300,
  "units-lb": 900,
  "units-bottle": 3500
};

export const MIN_SALES_PRICE_EXAMPLES: Record<string, number> = {
  "units-unit": 1700,
  "units-kg": 900,
  "units-g": 6,
  "units-litre": 1400,
  "units-ml": 4,
  "units-metre": 2800,
  "units-cm": 60,
  "units-mm": 12,
  "units-sqcm": 35,
  "units-oz": 230,
  "units-lb": 700,
  "units-bottle": 2800
};

export const QUANTITY_EXAMPLES: Record<string, string> = {
  "units-unit": "e.g. 50",
  "units-kg": "e.g. 25.5",
  "units-g": "e.g. 500",
  "units-litre": "e.g. 10",
  "units-ml": "e.g. 750",
  "units-metre": "e.g. 5.5",
  "units-cm": "e.g. 100",
  "units-mm": "e.g. 200",
  "units-sqcm": "e.g. 300",
  "units-oz": "e.g. 16",
  "units-lb": "e.g. 10",
  "units-bottle": "e.g. 24"
};

export const FORBIDDEN_CHARS_RE = /[<>{}|\\`]|\p{Cc}/u;

export const FORBIDDEN_CHARS_DESCRIPTION_RE = /[<>{}|\\`]|(?![\n\t])\p{Cc}/u;

export const ALLOWED_PRODUCT_NAME_RE =
  /^[\p{L}\p{N}\p{M} \-_.,;:'"!@#$%^*+=~/?()[\]&€£¥]+$/u;

export const ALLOWED_SINGLE_CHAR_RE =
  /[\p{L}\p{N}\p{M} \-_.,;:'"!@#$%^*+=~/?()[\]&€£¥]/u;

export const SUSPICIOUS_SEQUENCES_RE = /[?*]{2,}|[&]{2,}|[!]{3,}/u;
